module.exports = __webpack_public_path__ + "media/images/riders/small/ALAN_HATHERLY-38ddb4c1ee845a53f2b3fd1352ae82fd.png";